module.exports = __webpack_public_path__ + "img/java.daf025e4.png";